var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-input-group",
    { staticClass: "input-group-merge" },
    [
      _c("b-form-input", {
        attrs: { type: "text", placeholder: _vm.placeholder, size: "sm" },
        model: {
          value: _vm.internalValue,
          callback: function ($$v) {
            _vm.internalValue = $$v
          },
          expression: "internalValue",
        },
      }),
      _c(
        "b-input-group-append",
        { attrs: { "is-text": "" } },
        [_c("feather-icon", { attrs: { icon: "SearchIcon" } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }